<template>
    <b-container v-if="load.Loading" class="container-basic-spinner">
        <spinner />
    </b-container>
    <div v-else>

       <custom-table-list :options="standardBooks"
                          :fields="fields"
                          placeholder-search="Поиск книги стандартов"
                          edit-link="/Admin/StandardBooks/Edit" 
                          :apiVersion="apiHeaders['api-Version']"/>

    </div>
</template>
<script>
import apiService from '@/services/api.service'
import dialogService from '@/services/dialog.service'

import AllRoutes from '@/routes/all.routes'

import ApiHeaders from '@/store/models/ApiHeaders'

import Loading from '@/store/models/Loading'
import Spinner from '@/components/shared/Spinner'

import CustomTableList from '@/components/shared/CustomTableList'

export default {
    data: function() {
        let load = new Loading();
        let apiHeaders = new ApiHeaders().mapToDto(this.$route.query['api-Version']);
        this.getAll(load, apiHeaders);
        return {
            load: load,
            apiHeaders: apiHeaders,

            standardBooks: null,
            fields: [
                { 
                    key: 'Name', 
                    label: 'Наименование',
                    sortable: true
                },
                {
                    key: 'IsActive', 
                    label: 'Статус', 
                    sortable: true,
                    formatter: value => {
                        return value ? 'Активный' : 'Неактивный';
                    }
                }
            ]
                   
        }
    },
    methods: {
        getAll: function(load, apiHeaders) {
            load.Calculate(true);

            apiService.Admin.StandardBooks.GetAll(apiHeaders)
                .then(response => {
                    this.standardBooks = response.data;
                    load.Calculate(false);
                })
                .catch(error => load.Calculate(false));
        }
    },
    components: {
        Spinner,
        CustomTableList
    }
}
</script>
